import Logo from '../../assets/images/logo.png';
import pdfIcon from '../../assets/icons/pdf-file.svg';

export const assets = {
    Logo,
    pdfIcon
}